export const ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS = {
	tourSeenAt: 'enhance-orientation-tour:tourSeenAt',
	hasDismissedTour: 'enhance-orientation-tour:hasDismissedTour',
	hasCompletedTour: 'enhance-orientation-tour:hasCompletedTour',
	hasSeenFinishNudge: 'enhance-orientation-tour:hasSeenFinishNudge',
};

export const ENHANCE_ORIENTATION_EXPERIMENT_LAND = 'cc-onboarding-enhance-orientation-tour-land';
export const ENHANCE_ORIENTATION_EXPERIMENT_XFLOW = 'cc-onboarding-enhance-orientation-tour-xflow';
